// src/components/subscription/SubscriptionGuard.jsx

import React from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import SubscriptionRequired from './SubscriptionRequired';

// Higher-order component to protect features based on subscription
export function withSubscriptionGuard(WrappedComponent, requiredPlan = 'basic') {
  return function SubscriptionGuardedComponent(props) {
    const { subscription, isActive, getCurrentPlan } = useSubscription();
    
    if (!subscription) {
      return <div>Abonelik bilgileri yükleniyor...</div>;
    }
    
    if (!isActive()) {
      return <SubscriptionRequired requiredPlan={requiredPlan} />;
    }
    
    const currentPlan = getCurrentPlan();
    const planHierarchy = { free: 0, basic: 1, professional: 2 };
    
    const currentLevel = planHierarchy[currentPlan.id] || 0;
    const requiredLevel = planHierarchy[requiredPlan] || 1;
    
    if (currentLevel < requiredLevel) {
      return <SubscriptionRequired requiredPlan={requiredPlan} />;
    }
    
    return <WrappedComponent {...props} />;
  };
}

// Component to check usage limits
export function UsageLimitGuard({ type, children, fallback }) {
  const { checkUsageLimit } = useSubscription();
  const usageCheck = checkUsageLimit(type);
  
  if (!usageCheck.allowed) {
    return fallback || <SubscriptionRequired reason="usage_limit" type={type} />;
  }
  
  return children;
}

// Hook for checking subscription in components
export function useSubscriptionCheck() {
  const { subscription, isActive, getCurrentPlan, checkUsageLimit, hasFeature } = useSubscription();
  
  return {
    canAccess: (feature) => isActive() && hasFeature(feature),
    canUse: (type) => checkUsageLimit(type).allowed,
    isActive: isActive(),
    currentPlan: getCurrentPlan(),
    subscription
  };
}